import { render, staticRenderFns } from "./Haciendas.vue?vue&type=template&id=5ca99296&scoped=true&"
import script from "./Haciendas.vue?vue&type=script&lang=js&"
export * from "./Haciendas.vue?vue&type=script&lang=js&"
import style0 from "./Haciendas.vue?vue&type=style&index=0&id=5ca99296&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca99296",
  null
  
)

export default component.exports